module.exports = "/call-frontend/img/icon_cross_outline.24d5b7d0.svg";